import { render, staticRenderFns } from "./BasketCard.vue?vue&type=template&id=b7d5a466&scoped=true&"
import script from "./BasketCard.vue?vue&type=script&lang=js&"
export * from "./BasketCard.vue?vue&type=script&lang=js&"
import style0 from "./BasketCard.vue?vue&type=style&index=0&id=b7d5a466&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7d5a466",
  null
  
)

export default component.exports